import React, { useContext } from "react";
import { LangCtx } from "../../../../lib/context";

const TotalDoctors = (props) => {
    const { l } = useContext(LangCtx);

    return (
        <div className="clrCardBlock">
            <div className="clrCard lblueGrdntBg">
                <div className="clrCrdHdr">
                    <h2 className="clrCrdTxtL"><span>{l.total_doctors}</span></h2>
                </div>
                <div className="clrCrdBdy">
                    <div className="clrCrdRow">
                        <div className="clrCrdIconBox">
                            <img src="/images/icons/doctor-default.png"alt="icon" />
                        </div>
                        <div className="clrCrdInfoBox">
                            <div className="clrCntBox">
                                <span>{props.doctors}</span>
                                <div className="clrTxtBox">
                                    <span>{l.total_doctors}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TotalDoctors;